import clsx from 'clsx'

import { Flex } from 'components/common/flex/Flex'
import { Typography } from 'components/common/Typography/Typography'
import styles from 'components/heroBanner/animatedTitle/AnimatedTitle.module.scss'
import { ReactComponent as Title0 } from 'components/heroBanner/assets/title-0.svg'
import { ReactComponent as Title1 } from 'components/heroBanner/assets/title-1.svg'
import { ReactComponent as Title2 } from 'components/heroBanner/assets/title-2.svg'
import { ReactComponent as Title3 } from 'components/heroBanner/assets/title-3.svg'
import { ReactComponent as Title4 } from 'components/heroBanner/assets/title-4.svg'

export const AnimatedTitle = () => {
  return (
    <div className={styles.titleContainer}>
      <Flex justify="end" align="center">
        <Flex className={styles.tag}>
          <Typography type="s-heading" tag="p" className='italic' color="#282828">
            Get the green light
          </Typography>
        </Flex>
      </Flex>
      <Title0 className={clsx(styles.title, styles.title0)} />
      <Title1 className={clsx(styles.title, styles.title1)} />
      <Title2 className={clsx(styles.title, styles.title2)} />
      <Title3 className={clsx(styles.title, styles.title3)} />
      <Title4 className={clsx(styles.title, styles.title4)} />
      <Title3 className={clsx(styles.title, styles.title5)} />
      <Title2 className={clsx(styles.title, styles.title6)} />
      <Title1 className={clsx(styles.title, styles.title7)} />
    </div>
  )
}
